import styled from 'styled-components';

export const IconContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
`;
export const Item = styled.div`
    width: calc(100% * (1 / 5) - 30px - 1px);
    @media (max-width: 1500px) {
        width: calc(100% * (1 / 4) - 30px - 1px);
    }
    @media (max-width: 650px) {
        width: calc(100% * (1 / 3) - 30px - 1px);
    }
`;
export const IconWrapper = styled.div`
    padding: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
`;
export const Icon = styled.img`
    height: 32px;
`;
export const ItemBody = styled.div`
    text-align: center;
`;
